<template>
  <v-content>
     <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="8">
          <div v-if="!microsoft_error" class="text-uppercase">
            {{'Redirecting...'|translate}}
          </div>
          <div v-if="microsoft_error">
              <v-card>
                <v-alert
                  prominent
                  type="error"
                >
                  <v-row align="center">
                    <v-col class="grow">
                      <h3 class="text-h5">
                        {{error_message | translate}}
                      </h3>
                      {{"Oops there was an error."|translate}} 
                      {{error_description | translate}}
                      {{"Please contact Administrator." | translate}}
                    </v-col>
                    <v-col class="shrink">
                      <v-btn to="/login">{{"Go to Login" | translate}}</v-btn>
                    </v-col>
                  </v-row>
                </v-alert>
              </v-card>
          </div>
        </v-col>
      </v-row>   
     </v-container>
  </v-content>
</template>

<script>
import Vue from "vue";
import { MICROSOFTCALLBACK, LOGOUT,LOGIN, FETCH_VIDEO_DATA, PAGES_RESET_STATE,FETCH_STRIPE_SECRET_KEY, FETCH_STRIPE_ALL_CARDS, STRIPE_RESET_STATE, FETCH_LANGUAGES, FETCH_PAGES, RESET_STATE, GLOBALS_RESET_STATE } from "@/store/actions.type"
import { SET_LOADING, SET_LOGGED_IN,SET_CUR_LANGUAGE,RESET_ALL_PAGES_DATA, } from "@/store/mutations.type"

import { mapState } from "vuex";
import { mapGetters } from "vuex";
import store from "@/store"
export default {
  name: "MicrosoftLogin", 
  data() {
    return {
      valid: false,
      username: "",
      password: "",
      title: '',
      microsoft_error:false,
      error_message:null,
      error_description:null,
    };
  },
   methods: {
    async login() {
      if (this.$refs.form.validate()) {
        let username = this.username;
        let password = this.password;
        await this.$store
          .dispatch(LOGIN, { username, password })
          .then(async loginresp=> { 
            if(loginresp!= undefined && loginresp.success){
              if(loginresp !== undefined && loginresp.hasOwnProperty('success') && loginresp.success ==true){
                 await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                  if(resp.success){
                  await this.$store
                    .dispatch(FETCH_PAGES, "?lang_ids=" + loginresp.data.user.company.language.lang_id).then(resp => {
                      if (resp.success) {
                          this.$store.dispatch(FETCH_VIDEO_DATA, '').then(resp =>{ 
                            if(resp.success){
                              var date = new Date();
                              let days = days || 365;
                              date.setTime(+ date + (days * 86400000));
                              document.cookie ='company_domain='+location.host+'; domain='+ process.env.VUE_APP_ENV_DOMAIN +'; expires='+date.toGMTString()+'; path=/;'
                              this.$store.commit(SET_LOADING, false)
                              if(loginresp.data.user.roles.length == 1 && loginresp.data.user.roles[0] == 5)
                              this.$router.push("/drafts")
                              else
                              this.$router.push("/dashboard")
                            }
                        })

                      }
                    });
                  }
                }) 

    if(store.state.auth.user.company.account_type == "on-demand"){
      await this.$store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent").then(resp => {
        if (resp.success) {

          this.$store.commit(SET_LOADING, false);
        }
      }); 
   }

    if (
      store.state.auth.user.card_brand !== null &&
      store.state.auth.user.company.account_type == "on-demand"
    ) {

        await this.$store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
          if (resp.success) {
            this.$store.commit(SET_LOADING, false);
          }
        });
    }


              }
             
          }else{
            this.$store.commit(SET_LOADING, false)
          } });
      }
    },
     async microsoftlogin() {
        await this.$store
          .dispatch(LOGIN)
          .then(async loginresp=> { 
            if(loginresp!= undefined && loginresp.success){
              if(loginresp !== undefined && loginresp.hasOwnProperty('success') && loginresp.success ==true){
                 await this.$store.dispatch(FETCH_LANGUAGES, '').then(async resp =>{
                  if(resp.success){
                  await this.$store
                    .dispatch(FETCH_PAGES, "?lang_ids=" + loginresp.data.user.company.language.lang_id).then(resp => {
                      if (resp.success) {
                          this.$store.dispatch(FETCH_VIDEO_DATA, '').then(resp =>{ 
                            if(resp.success){
                              var date = new Date();
                              let days = days || 365;
                              date.setTime(+ date + (days * 86400000));
                              document.cookie ='company_domain='+location.host+'; domain='+ process.env.VUE_APP_ENV_DOMAIN +'; expires='+date.toGMTString()+'; path=/;'
                              this.$store.commit(SET_LOADING, false)
                              if(loginresp.data.user.roles.length == 1 && loginresp.data.user.roles[0] == 5)
                              this.$router.push("/drafts")
                              else
                              this.$router.push("/dashboard")
                            }
                        })

                      }
                    });
                  }
                }) 

    if(store.state.auth.user.company.account_type == "on-demand"){
      await this.$store.dispatch(FETCH_STRIPE_SECRET_KEY, "setup-intent").then(resp => {
        if (resp.success) {

          this.$store.commit(SET_LOADING, false);
        }
      }); 
   }

    if (
      store.state.auth.user.card_brand !== null &&
      store.state.auth.user.company.account_type == "on-demand"
    ) {

        await this.$store.dispatch(FETCH_STRIPE_ALL_CARDS, "list-card").then(resp => {
          if (resp.success) {
            this.$store.commit(SET_LOADING, false);
          }
        });
    }


              }
             
          }else{
            this.$store.commit(SET_LOADING, false)
          } });
    },
    async logout(){
        Promise.all([   
            await this.$store.dispatch(STRIPE_RESET_STATE),
            await  this.$store.commit(RESET_ALL_PAGES_DATA),
            await this.$store.dispatch(PAGES_RESET_STATE),
            await this.$store.dispatch(RESET_STATE),
            await this.$store.dispatch(GLOBALS_RESET_STATE), 
            await this.$store.dispatch(LOGOUT),
            await this.$store.commit(SET_LOGGED_IN, false),          
          ]).finally(() => { 
            this.$router.push("/login");
          });

    },
    async selLanguage(language) {
      await this.$store.commit(SET_CUR_LANGUAGE, language);
    },
    async changedLanguage(value) {
      Vue.i18n.set(value);
      let selectedLanguage = this.languages.find(x => value == x.lang_code);
      this.selLanguage(selectedLanguage)
    },
  },
  computed: {
    ...mapState({
      errors: state => state.auth.autherrors,
      }),
      languages(){
        let data = [{"lang_id":1,"lang_name": this.$t("English"),"lang_code":"en"},{"lang_id":2,"lang_name": this.$t("German"),"lang_code":"de"}]
        return data
      },
      selectedLanguage(){
        return this.curLanguage !== null ? this.curLanguage.lang_code : this.allowregistration.lang_code
      },
    ...mapGetters([
      "allowregistration",'curLanguage','loadingdata'
    ]),   
    isAuthenticated : function(){ return this.$store.getters.isAuthenticated}  
  },
  async created(){
    this.changedLanguage(this.selectedLanguage)
      const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has('error'))
        {
            this.error_message = urlParams.get('error').replace(/_/g, ' ').toUpperCase();
            if(urlParams.has('error_description'))
            {
              this.error_description = urlParams.get('error_description')
            }
            this.microsoft_error=true;
            // this.$router.push("/login")
        }
        else{
            await store.dispatch(MICROSOFTCALLBACK, queryString).then(resp => {
                if (resp.success) {
                    this.$router.push("/dashboard")
                    if(resp.data.user.roles.length == 1 && resp.data.user.roles[0] == 5)
                        this.$router.push("/drafts")
                    else
                        this.$router.push("/dashboard")
                    store.commit(SET_LOADING, false);
                }
                else{
                  this.error_message = resp.data.message.toUpperCase();
                  this.microsoft_error=true;
                }
            })
        }
        
  }
};
</script>
